import React from 'react';
import classNames from 'classnames';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { BreadcrumbsV2 } from '@uncinc/react-drupal-core';
import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import { ButtonWrapper, ParagraphsRenderer } from '../../../components';
import useLayoutVariables from '../../../hooks/useLayoutVariables';
import type { NodeBasicPage as Type } from '../../../types/uncinc_profile/nodes';

import './style.scss';

interface BasicPageProps {
  entity: ImmutableEntity<Type>;
  className?: string;
}

const NodeBasicPage: React.FC<BasicPageProps> = ({ entity, className }) => {
  const {
    breadcrumbsColClasses,
    heroTextColClasses,
  } = useLayoutVariables('basicPage');

  const classes = classNames('Node', 'NodeBasicPage', className);
  const basicPage = entity.toJS();
  const title = basicPage.title[0].value;
  const body = basicPage.body[0]?.processed;
  const link = basicPage.field_link[0];
  const linkTitle = link?.title;
  const linkUrl = link?.alias || link?.uri;
  const linkSecondary = basicPage.field_link_secondary[0];
  const linkSecondaryTitle = linkSecondary?.title;
  const linkSecondaryUrl = linkSecondary?.alias || linkSecondary?.uri || '';
  const paragraphs = basicPage.field_paragraphs;

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>
      <div className="NodeBasicPage__hero">
        <Container>
          <div className="row">
            <div className={breadcrumbsColClasses}>
              <BreadcrumbsV2 showHomeIcon={false} hideOnHighestLevel />
            </div>
          </div>
          <div className="row">
            <div className={heroTextColClasses}>
              <div className="NodeBasicPage__hero__text-wrapper">
                <div className="NodeBasicPage__hero__text">
                  <h1 className="NodeBasicPage__title" itemProp="title">
                    {title}
                  </h1>

                  {body && (
                    <WysiwygField
                      className="NodeBasicPage__body body--large"
                      property="schema:text"
                      html={body}
                    />
                  )}

                  {(link || linkSecondary) && (
                    <div className="NodeBasicPage__links">
                      {link && (
                        <ButtonWrapper href={linkUrl}>
                          {linkTitle}
                        </ButtonWrapper>
                      )}
                      {linkSecondary && (
                        <ButtonWrapper href={linkSecondaryUrl} type="secondary">
                          {linkSecondaryTitle}
                        </ButtonWrapper>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>

      <ParagraphsRenderer className="NodeBasicPage__paragraphs" paragraphs={paragraphs} />
    </article>
  );
};

export default NodeBasicPage;
